<template>
  <div class="slider" style="margin: 15px 0 10px;">
    <!-- <van-slider
      v-model="item.value.sliderAttribute.answer"
      :min="Number(item.value.sliderAttribute.min)"
      :max="Number(item.value.sliderAttribute.max)"
      active-color="#1a8feb"
    >
      <template #button>
        <div class="custom-button">{{ Number(item.value.sliderAttribute.answer) }}</div>
      </template>
    </van-slider>-->
    <el-slider
      v-model="item.value.sliderAttribute.answer"
      :min="Number(item.value.sliderAttribute.min)"
      :max="Number(item.value.sliderAttribute.max)"
    ></el-slider>
  </div>
</template>
<script>
export default {
  props: ['item', 'pindex'],
  data() {
    return {
      // 默认值
      value: '',
    }
  },
  created: function () {
    this.item.value.sliderAttribute.answer = Number(
      this.item.value.sliderAttribute.answer
    )
    console.log('1111',this.item, typeof this.item.value.sliderAttribute.min)
  },
  methods: {},
}
</script>
<style scoped>
.custom-button {
  width: 26px;
  color: #fff;
  font-size: 10px;
  line-height: 18px;
  text-align: center;
  background-color: #1a8feb;
  border-radius: 100px;
}
</style>


